import React, { Component } from 'react';

const makeTimeList = () => {
    let timeList = [];
    let hours = "00";
    for (let i = 0; i < 25; i++) {
        let minutes = "00";
        if (hours !== "24") {
            for (let j = 0; j < 4; j++) {
                timeList.push([hours + ":" + minutes]);
                minutes = (parseInt(minutes, 10) + 15).toString();
            }
            let nextHour = (parseInt(hours, 10) + 1).toString();
            hours = (nextHour.length === 1) ? "0" + nextHour : nextHour;
        }
        else if (hours === "24") {
            timeList.push([hours + ":" + minutes]);
        }
    }
    return timeList;
}

const TimePicker = () => {
    let timeList = makeTimeList();
    return timeList.map((time, i) => {
        return <option key={i} value={time}>{time}</option>
    });
};

export default TimePicker;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/components/TimePicker.jsx